module.exports = __webpack_public_path__ + "img/takeout.54c036e3.svg";